import {CssBaseline, responsiveFontSizes, StyledEngineProvider} from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useMemo } from 'react';
import useConfig from "../hooks/theme/useConfig";
import componentsOverride from './overrides';
import Palette from "./palette.jsx";
import CustomShadows from './shadows.jsx';
import Typography from './typography.jsx';
import Box from "@mui/material/Box";

// ==============================|| DEFAULT THEME - MAIN  ||============================== //

export default function ThemeCustomization({ children }) {
	const { themeDirection, mode, presetColor, fontFamily, fontFamilySpecial } = useConfig()
	const theme = useMemo(() => Palette(), []);
	const themeTypography = useMemo(() => Typography(), []);
	const themeCustomShadows = useMemo(() => CustomShadows(theme), [theme]);

	const themeOptions = useMemo(() => ({
		direction: themeDirection,
		shape: {
			borderRadius: 12
		},
		spacing: 8,
		palette: theme.palette,
		typography: {
			...themeTypography,
			fontFamily: `-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif`
		},
		breakpoints: {
			values: {
				xs: 0,
				sm: 600,
				md: 900,
				lg: 1200,
				xl: 1536
			}
		},
		mixins: {
			toolbar: {
				minHeight: 60,
				paddingTop: 9.5,
				paddingBottom: 8
			}
		},
		customShadows: themeCustomShadows
	}), [themeDirection, theme.palette, themeCustomShadows, themeTypography]);

	let themes = createTheme(themeOptions);
	themes = responsiveFontSizes(themes);
	themes.components = componentsOverride(themes);
	
	return (
		<StyledEngineProvider injectFirst>
			<ThemeProvider theme={themes}>
				<CssBaseline/>
				{children}
			</ThemeProvider>
		</StyledEngineProvider>
	);
}